module.exports = __webpack_public_path__ + "img/GH-corporate-037.e9df7f77.jpg";